import type { Product, ProductVariant, Variant } from '../../types'

/**
 * Type guard: `Product.variants` is typed as `ProductVariant[] | Variant[]`
 * because the listing endpoint returns the summary `ProductVariant` shape and
 * the detail endpoint returns the full `Variant` shape. At the SSR pages we
 * know we called the detail endpoint, so we can narrow to `Variant[]`.
 *
 * An item is a full `Variant` when it has the `uuid` + `slug` pair. The
 * summary `ProductVariant` has neither.
 */
export function isFullVariantArray(
  variants: Product['variants'] | undefined | null,
): variants is Variant[] {
  if (!Array.isArray(variants) || variants.length === 0) return false
  const first = variants[0] as Partial<Variant> & Partial<ProductVariant>
  return typeof first.uuid === 'string' && typeof first.slug === 'string'
}
